<template>
  <div class="row">
  <div class="col-xl-2 mediaicon pr-0 mr-0"> 
      <img v-if="resource.mediaType === 'Image'" src="/static/img/ic-media-picture.png">
      <img v-else-if="resource.mediaType === 'Text' || resource.mediaType === 'Other'" src="/static/img/ic-media-document.png">
      <img v-else-if="resource.mediaType === 'Website'" src="/static/img/ic-media-link.png">
      <img v-else-if="resource.mediaType === 'Audio'" src="/static/img/ic-media-audio.png">
      <img v-else-if="resource.mediaType === 'Linked Video'" src="/static/img/ic-media-video.png">
      <img v-else src="/static/img/ic-media-document.png">
  </div>
  <div class="col-lg-12 col-xl-10">
    <h3><router-link :to="{ name: 'resourceView', params: { id: resource.id }}">{{ resource.title }}</router-link></h3>
    
    <div v-if="readMore">
      <template>
  <VueReadMoreSmooth>
    {{ resource.description }}
  </VueReadMoreSmooth>
  </template></div>
  <div v-else>
    <p>{{ resource.description }}</p>
    </div>
  </div>
  </div>
</template>

<script>

import VueReadMoreSmooth from "vue-read-more-smooth";
 
export default {
  name: 'ResourceMedia',
  components: { VueReadMoreSmooth },
  props: {
    resource: Object,
    readMore: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    adjustIcon (mediaType) {
      // load the proper icon given the media type 
      if (mediaType === 'Image') {
        return 'image'
      } else if (mediaType === 'Audio') {
        return 'file-audio'
      } else if (mediaType === 'Linked Video') {
        return 'play-circle'
      } else if (mediaType === 'Website') {
        return 'link'
      } else if (mediaType === 'Text') {
        return 'file-alt'
      } else if (mediaType === 'Pdf') {
        return 'file-pdf'
      } else {
        return 'file-alt'
      }
    },
    adjustIconSize (mediaType) {
      // load the proper icon given the media type 
      if (mediaType === 'Image') {
        return '4x'
      } else if (mediaType === 'Audio') {
        return '5x'
      } else if (mediaType === 'Linked Video') {
        return '4x'
      } else if (mediaType === 'Website') {
        return '4x'
      } else if (mediaType === 'Text') {
        return '5x'
      } else if (mediaType === 'Pdf') {
        return '5x'
      } else {
        return '5x'
      }
    },
    adjustColor (mediaType) {
      // load the proper icon given the media type
      if (mediaType === 'Image') {
        return 'image'
      } else if (mediaType === 'Audio') {
        return 'color: #f0d6f1'
      } else if (mediaType === 'Linked Video') {
        return 'color: #ff6c6c'
      } else if (mediaType === 'Website') {
        return 'color: #95c9ff'
      } else if (mediaType === 'Text') {
        return 'color: #fff37a'
      } else if (mediaType === 'Pdf') {
        return 'color: red'
      } else {
        return 'color: #fff37a'
      }
    }
  }
}
</script>

<style scoped>
.media-wrapper {
  width: 64px;
  height: 64px
}
</style>



// WEBPACK FOOTER //
// src/components/resources/ResourceMedia.vue